document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.aw-card-swatch');
  if (!swatch) return;

  e.preventDefault();

  const card = swatch.closest('.card-wrapper');
  if (!card) return;

  // Update active state
  card.querySelectorAll('.aw-card-swatch').forEach(function (s) {
    s.classList.remove('aw-card-swatch--active');
  });
  swatch.classList.add('aw-card-swatch--active');

  // Swap main card image
  const mainImg = card.querySelector('.card__media img');
  if (!mainImg) return;

  const newSrc = swatch.dataset.imageSrc;
  const newSrcset = swatch.dataset.imageSrcset;

  if (newSrc) mainImg.src = newSrc;
  if (newSrcset) mainImg.srcset = newSrcset;
});
